module.exports = __webpack_public_path__ + "img/login.7133ade4.jpeg";